import { useEffect } from "react";

export function useScrollReveal(deps: React.DependencyList = []) {
  useEffect(() => {
    const els = document.querySelectorAll<HTMLElement>(".reveal");
    const timers: number[] = [];
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e, i) => {
          if (e.isIntersecting) {
            timers.push(
              window.setTimeout(() => e.target.classList.add("visible"), i * 80)
            );
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    els.forEach((el) => obs.observe(el));
    return () => {
      obs.disconnect();
      timers.forEach(clearTimeout);
    };
  }, deps);
}
